import { styled } from '@mui/system';
import { Typography } from '@mui/material';

export const PaymentConfirmMainCard = styled('div')({
  width: '100%',
  height: '100%',
  backgroundColor: 'white',
  borderRadius: '12px',
  padding: '12px',
});

export const EmailNotificationTypography = styled(Typography)({
  fontSize: '12px',
  fontWeight: 400,
  color: '#2196F3',
  lineHeight: '24px',
  textAlign: 'left',
  margin: '12px 0px 0px 0px',
});

export const ErrorNotificationTypography = styled(Typography)({
  fontSize: '12px',
  fontWeight: 400,
  color: '#F44336',
  lineHeight: '24px',
  textAlign: 'left',
  margin: '12px 0px 0px 0px',
});
